import Pica from 'pica';
import moment from 'moment';
import momentCache from "@/services/momentCache"
const pica = Pica();

export default {
    // Iterates through the items of a lists
    // Each each item, checks if already exists in the unique list based on the itemComparer
    // If doesn't already exists, adds to unique list
    filterUnique(list, itemComparer){
        if(itemComparer == null){
            itemComparer = (a, b) => a == b;
        }

        let unique = [];

        list.forEach(x => {
            if(unique.some(y => itemComparer(y, x))){
                return;
            }

            unique.push(x);
        })

        return unique;
    },
    sortDescending(getCompareProperty){
        return (a, b) => {
            if(getCompareProperty(a) > getCompareProperty(b))
                return -1;

            if(getCompareProperty(a) < getCompareProperty(b))
                return 1;

            return 0;
        };
    },
    sortAscending(getCompareProperty){
        return (a, b) => {
            if(getCompareProperty(a) > getCompareProperty(b))
                return 1;

            if(getCompareProperty(a) < getCompareProperty(b))
                return -1;

            return 0;
        };
    },
    getDates(startDateParam, stopDateParam) {
        var dateArray = [];
        var currentDate = momentCache.getMoment(startDateParam);
        var stopDate = momentCache.getMoment(stopDateParam);
        while (currentDate <= stopDate) {
            dateArray.push(momentCache.getMoment(currentDate).format('YYYY-MM-DD'))
            currentDate = momentCache.createMoment(currentDate).add(1, 'days');
        }
        return dateArray;
    },
    parseDateYMD(dateString){
        let year = parseInt(dateString.substring(0, 4));
        let month = parseInt(dateString.substring(5, 7));
        let day = parseInt(dateString.substring(8, 10));

        return new Date(year, month - 1, day);
    },
    formatDateYMD(date) {
        if (moment.isMoment(date)) {
            return date.format("YYYY-MM-DD");
        }

        date = new Date(date);
        let day = date.getDate() + "";
        if(day.length == 1){
            day = "0" + day;
        }
        let month = (date.getMonth() + 1) + "";
        if(month.length == 1){
            month = "0" + month;
        }

        let year = date.getFullYear();

        return year + "-" + month + "-" + day;
    },
    formatDateDMY(date, separator ='/'){
        date = new Date(date);
        let day = date.getDate() + "";
        if(day.length == 1){
            day = "0" + day;
        }
        let month = (date.getMonth() + 1) + "";
        if(month.length == 1){
            month = "0" + month;
        }

        let year = date.getFullYear();

        return day + separator + month + separator + year;
    },
    formatDateDMYHMS(date){
        date = new Date(date);
        let hour = date.getHours() + "";
        if(hour.length == 1){
            hour = "0" + hour;
        }
        let minute = date.getMinutes() + "";
        if(minute.length == 1){
            minute = "0" + minute;
        }
        let second = date.getSeconds() + "";
        if(second.length == 1){
            second = "0" + second;
        }

        return this.formatDateDMY(date) + " " + hour + ":" + minute + ":" + second;
    },
    formatDateYMDHMS(date){
        if (moment.isMoment(date)) {
            return date.format("YYYY-MM-DD HH:mm:ss");
        }

        date = new Date(date);
        let hour = date.getHours() + "";
        if(hour.length == 1){
            hour = "0" + hour;
        }
        let minute = date.getMinutes() + "";
        if(minute.length == 1){
            minute = "0" + minute;
        }
        let second = date.getSeconds() + "";
        if(second.length == 1){
            second = "0" + second;
        }

        return this.formatDateYMD(date) + " " + hour + ":" + minute + ":" + second;
    },
    formatDateLong(date) {
        return momentCache.getMoment(date).format("dddd Do MMMM YYYY");
    },
    sameDay(a, b){
        a = new Date(a);
        b = new Date(b);
        return a.getDate() == b.getDate() && a.getMonth() == b.getMonth() && a.getFullYear() == b.getFullYear();
    },
    sameWeek(a, b, weekStartOffset = 0){
        // Same week if both dates' previous sundays are the same day
        // WeekStartOffset changes it from Sunday to Monday, Tuesday, etc
        a = new Date(a);
        let aDayOffset = a.getDay() - weekStartOffset;
        if(aDayOffset < 0){
            aDayOffset += 7;
        }
        a.setDate(a.getDate() - aDayOffset);

        b = new Date(b);
        let bDayOffset = b.getDay() - weekStartOffset;
        if(bDayOffset < 0){
            bDayOffset += 7;
        }
        b.setDate(b.getDate() - bDayOffset);

        return this.sameDay(a, b);
    },
    formatWeekDay(date) {
        if (moment.isMoment(date)) {
            return date.format("dddd");
        }
        else {
            return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][new Date(date).getDay()];
        }
    },
    formatMonth(date) {
        if (moment.isMoment(date)) {
            return date.format("MMMM");
        }
        else {
            return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][new Date(date).getMonth()];
        }
    },
    formatMonthDay(date) {
        if (moment.isMoment(date)) {
            return date.format("Do");
        }

        date = new Date(date);
        let day = date.getDate();

        if(day % 100 < 10 || day % 100 > 19){
            if(day % 10 == 1){
                return day + "st";
            }

            if(day % 10 == 2){
                return day + "nd";
            }

            if(day % 10 == 3){
                return day + "rd";
            }
        }

        return day + "th";
    },
    isSame(a, b){
        if(typeof a === "number"){
            a = a + "";
        }
        if(typeof b === "number"){
            b = b + "";
        }

        return a == b;
    },
    isNullOrEmpty(a){
        return a == null || (typeof a === "string" && a == "");
    },
    stringIsBlank(str) {
        // !str tests for null or undefined
        // /^\s*$/ tests for a string full of nothing but whitespace
        return (!str || /^\s*$/.test(str));
    },
    loadFileToImage(file){
        return new Promise((resolve) => {
            const fr = new FileReader();
            fr.readAsDataURL(file);
            fr.addEventListener("load", (e) => {
                const image = new Image();
                image.src = e.target.result;

                image.addEventListener("load", () => {
                    resolve(image);
                });
            });
        });
    },
    async resizeUntilBelow(image, mimeType, maxFileSize){
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;

        let blob = null;
        while(blob == null || blob.size > maxFileSize){
            let width = canvas.width;
            let height = canvas.height;

            if(blob != null && blob.size > maxFileSize){
                let reductionPercentage = maxFileSize / blob.size;

                // the divide and multiply by 1024 ensures that the image will only be resized with a width/height of a multiple of 1024 px
                // this is because of a requirement in a story for images to not be resized below 1024 px
                // if this code is accesed from another place where this requirement does not exist, consider adding an argument to the function to disable this particular processing

                if(canvas.height > canvas.width){
                    height = Math.floor((canvas.height * reductionPercentage) / 1024) * 1024;
                    width = (height / canvas.height) * canvas.width;
                } else {
                    width = Math.floor((canvas.width * reductionPercentage) / 1024) * 1024;
                    height = (width / canvas.width) * canvas.height;
                }

                console.log("Photo too large, must be reduced to " + (reductionPercentage * 100) + "%");
                console.log("Resize to " + width + "x" + height + " from " + canvas.width + "x" + canvas.height);

                if(width == 0 || height == 0 || (width == canvas.width && height == canvas.height)){
                    console.log("Image cannot be resized small enough");
                    return null;
                }
            }

            canvas.width = width;
            canvas.height = height;
            await pica.resize(image, canvas);

            blob = await pica.toBlob(canvas, mimeType);
            
            console.log("New size: " + blob.size);
        }

        return blob;
    },
    daysBack(date, days){
        date = new Date(date);
        date.setDate(date.getDate() - days);

        return momentCache.getMoment(date).format("YYYY-MM-DD");
    },
    daysForward(date, days){
        date = new Date(date);
        date.setDate(date.getDate() + days);

        return date;
    },
    getPreviousDayOfWeek(day) {
        var date = new Date();
        while(date.getDay() != day) {
            date = this.daysBack(date, 1);
        }
        return date.setHours(0, 0, 0, 0);
    },
    getNextDayOfWeek(day) {
        var date = new Date();
        date = this.daysForward(date, 1);
        while(date.getDay() != day) {
            date = this.daysForward(date, 1);
        }
        return date.setHours(0, 0, 0, 0);
    },
    getPreviousMonday() {
        var date = new Date();
        if(date.getDay() == 1) {
            return date.setHours(0, 0, 0, 0);
        }
        return this.getPreviousDayOfWeek(1);
    },
    getFollowingSunday() {
        var date = new Date();
        if(date.getDay() == 0) {
            return date.setHours(0, 0, 0, 0);
        }
        return this.getNextDayOfWeek(0);
    },
    sameDateOrFuture(date){
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        return new Date(date) >= today;
    },
    tommorrowOrFuture(date){
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        var tommorrow = today.setDate(today.getDate() + 1); 
        return new Date(date) >= tommorrow;
    },
    dateInRange(start, end, date){
        start = new Date(start);
        end = new Date(end);
        date = new Date(date);
        return date >=start && date <=end;
    },
    addHours(date, hours) {
        date = new Date(date);
        date.setHours(date.getHours() + hours);
        return date;
    },
    getDaysOfTheWeek(date) {
        var monday = new Date(date);
        while(monday.getDay() != 1) {
            monday = this.daysBack(monday, 1);
        }
        var nextSunday = new Date(date);
        while(nextSunday.getDay() != 0) {
            nextSunday = this.daysForward(nextSunday, 1);
        }

        var weeks =[monday];
        var nextDay = this.daysForward(monday, 1);
        while(!this.sameDay(nextDay, nextSunday)) {
            weeks.push(nextDay);
            nextDay = this.daysForward(nextDay, 1);
        }
        weeks.push(nextSunday);
        return weeks;
    },
    thousandsSeparators(num)
    {
        var num_parts = num.toString().split(".");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return num_parts.join(".");
    },
    checkAndSetMaxNumberLimit(value, maxNumber){
        if(!value) {
            return value;
        }
        // Some reasonable limits
        if(value >= maxNumber){
            value = maxNumber;
        } else if(value <= -maxNumber){
            value = -maxNumber;
        }

        // Handle unusually precise JS rounding errors (i.e., 110.00000000000001)
        value = Math.round(value * 1000) / 1000;

        return value;
    },
    convertTrayToKG(value, valueTypeCode, numInTray, aveKgsPerUnit) {
        if(valueTypeCode.toLowerCase() == 'tray' && numInTray && aveKgsPerUnit) {
            return value * numInTray * aveKgsPerUnit;
        } else {
            return value;
        }
    },
    convertKGToTray(value, valueTypeCode, numInTray, aveKgsPerUnit) {
        if(valueTypeCode.toLowerCase() == 'tray' && numInTray && aveKgsPerUnit) {
           return Math.round((value / numInTray / aveKgsPerUnit) * 100) / 100;
       } else {
           return value;
       }
   },
   convertKGToPunnets(value, valueTypeCode, aveKgsPerUnit) {
        if(valueTypeCode.toLowerCase() == 'tray'  && aveKgsPerUnit) {
        return Math.round((value  / aveKgsPerUnit) * 100) / 100;
        } else {
            return value;
        }
    },
    getPickRateUnit(valueTypeCode) {
        if(valueTypeCode && valueTypeCode.toLowerCase() == "tray") {
            return "punnets/hr"
        }
        return "kg/hr";
    },
    endOfYearFromDate(date){
        date = new Date(date);
        date.setFullYear(date.getFullYear() + 1); // Forwards 1 year
        date.setDate(date.getDate() - 1); // Back 1 day

        return date;
    },
    addToDate(date, ms){
        return new Date(new Date(date).getTime() + ms);
    },
    dateContainedWithin(start, end, date){
        start = new Date(start);
        end = new Date(end);
        date = new Date(date);

        return start <= date && end >= date;
    },
    weeksForward(date, weeks){
        date = new Date(date);
        date.setDate(date.getDate() + weeks * 7);

        return date;
    },
    formatNumber(value, decimalPlaces){
      if(value == null || value === ""){
        return null;
      }

      let numericValue = parseFloat(`${value}`);

      return numericValue.toFixed(decimalPlaces);
    },
    focusNextRefElement(ref, currentElementKey) {
        if(ref) {
            let keys = Object.keys(ref);
            let nextIndex = keys.indexOf(currentElementKey) + 1;
            let nextItem = keys[nextIndex];
            if(ref[nextItem]) {
                if (typeof  ref[nextItem].focus == 'function') {
                    ref[nextItem].focus();
                } else if (ref[nextItem].$el && typeof ref[nextItem].$el.focus == 'function') {
                    ref[nextItem].$el.focus();
                }
            }
        }
    },
    focusRefElement(ref, currentElementKey) {
        if (ref) {
          
            if (ref[currentElementKey]) {
                if (typeof ref[currentElementKey].focus == 'function') {
                    ref[currentElementKey].focus();
                } else if(ref[currentElementKey].$el && typeof ref[currentElementKey].$el.focus == 'function') {
                    ref[currentElementKey].$el.focus();
                }
            }
        }
    }
}
